import { assessmentList, courseAssessmentList, coursePublishedAssessmentList } from "constants/assessment";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addAssessment = async (bodyData) => {
  try {
    const res = await api.add_assessment(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getAssessmentList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_assessment_list(pageNum, filters);
    dispatch({ type: assessmentList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: assessmentList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getAssessmentByCourseId = async (dispatch, courseId, pageNum, filters) => {
  try {
    const res = await api.get_assessment_by_course_id(courseId, pageNum, filters);
    dispatch({ type: courseAssessmentList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: courseAssessmentList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getAssessmentById = async (id) => {
  try {
    const res = await api.get_assessment_by_id(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const updateAssessmentById = async (id, bodyData) => {
  try {
    const res = await api.update_assessment_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteAssessment = async (assessmentID) => {
  try {
    const res = await api.delete_assessment(assessmentID);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getPublishedAssessmentByCourseId = async (dispatch, courseId, traineeID, pageNum, filters) => {
  try {
    const res = await api.get_published_assessment_by_course_id(courseId, traineeID, pageNum, filters);
    dispatch({ type: coursePublishedAssessmentList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: coursePublishedAssessmentList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};